import React from 'react';
import { ChatWr, GameScenes, RightContainerFooter } from '@pascal/pascal-core';
import { BetHistoryWrapper, LiveBetsWrapper, TopAndCurrentWinnersWrapper } from '../common';
import { globalTranslationKeys } from '../../enums';
import LeftColumn from '../common/leftColumn';

const GameSceneComponents = ({ gameScene }) => {
  if (GameScenes.Bets === gameScene) {
    const rightContainerTabs = [
      { name: globalTranslationKeys.LiveBets },
      { name: globalTranslationKeys.History, isBetHistory: true },
      { name: globalTranslationKeys.TopWinners },
    ];

    const rightContainerTabsContainers = [
      <LiveBetsWrapper />,
      <BetHistoryWrapper />,
      <TopAndCurrentWinnersWrapper isTopWinners />,
    ];
    return (
      <RightContainerFooter
        tabs={rightContainerTabs}
        tabContainers={rightContainerTabsContainers}
      />
    );
  }
  if (GameScenes.Results === gameScene) {
    return <LeftColumn />;
  }
  if (GameScenes.Chat === gameScene) {
    return <ChatWr />;
  }

  return null;
};

export const ActiveGameScene = ({ gameScene }) => {
  if (gameScene) {
    return <GameSceneComponents gameScene={gameScene} />;
  }
  return <></>;
};
